import { request } from '@umijs/max';
import type { ApiResponse } from '@/typings.d';

const AUTH_BASE_URL = "/api/v1/auth"; // 与 Vue 项目一致

/** 登录请求参数 (适配React项目，移除了验证码) */
export interface LoginParams {
  /** 用户名 */
  username: string;
  /** 密码 (SHA256加密) */
  passwordSha: string;
}

/** 登录接口实际返回数据结构 */
export interface LoginData {
  /** 访问token */
  accessToken?: string;
  /** 过期时间(单位：毫秒) */
  expires?: number;
  /** 刷新token */
  refreshToken?: string;
  /** token 类型 */
  tokenType?: string;
}

/** 验证码接口实际返回数据结构 */
export interface CaptchaData {
  /** 验证码缓存key */
  captchaKey: string;
  /** 验证码图片Base64字符串 */
  captchaBase64: string;
}

/**
 * 登录接口
 * POST /api/v1/auth/login
 */
export async function login(body: LoginParams, options?: { [key: string]: any }): Promise<ApiResponse<LoginData>> {
  const formData = new FormData();
  formData.append("username", body.username);
  formData.append("passwordSha", body.passwordSha);
  // 验证码相关字段已根据当前需求移除
  return request<ApiResponse<LoginData>>(`${AUTH_BASE_URL}/login`, {
    method: 'POST',
    data: formData,
    // 使用 FormData 时不需要显式设置 Content-Type，浏览器会自动处理
    ...(options || {}),
  });
}

/**
 * 注销接口
 * DELETE /api/v1/auth/logout
 */
export async function logout(options?: { [key: string]: any }): Promise<ApiResponse<null>> {
  return request<ApiResponse<null>>(`${AUTH_BASE_URL}/logout`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/**
 * 获取验证码接口 (保留以便将来使用)
 * GET /api/v1/auth/captcha
 */
export async function getCaptcha(options?: { [key: string]: any }): Promise<ApiResponse<CaptchaData>> {
  return request<ApiResponse<CaptchaData>>(`${AUTH_BASE_URL}/captcha`, {
    method: 'GET',
    ...(options || {}),
  });
}
